import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import Loader from './components/Loader.vue';
Vue.component('Loader', Loader)

Vue.config.productionTip = false

window.addEventListener("beforeinstallprompt", function (event) {
  event.preventDefault();
  store.commit("install/setAddToHomeScreen", event);
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')





